<template>
  <div>
    <span class="promotion-label-container" v-if="vm.promotionLabel">
      <span class="promotion-label">
        {{ vm.promotionLabel }}
      </span> </span
    >{{ " " }}
    <span class="price-wrapper">
      <span v-if="vm.oldPrice" class="old-price-wrapper">
        <span class="old-price">
          <span class="amount">{{ vm.oldPrice }}</span>
          <span class="currency">&euro;</span>
        </span> </span
      >{{ " " }}
      <span class="price" v-if="vm.mode === 'intro'">
        <span class="starting-offer">
          <template v-if="vm.intro.starting.isFree">
            <span class="starting-offer-detail">{{
              vm.intro.starting.durationText
            }}</span>
          </template>
          <template v-else>
            <span class="amount">{{ vm.intro.starting.amount }}</span>
            <span class="currency">&euro;</span>
            <span class="starting-offer-detail">{{
              vm.intro.starting.durationText
            }}</span>
          </template>
        </span>
        <span v-if="vm.intro.after" class="after-starting-offer">
          <span class="after-starting-offer-details"
            >{{ vm.intro.after.thenLabel }}&nbsp;</span
          >
          <template v-if="vm.intro.after.amount">
            <span class="amount">{{ vm.intro.after.amount }}</span>
            <span class="currency">&euro;</span>
            <span
              v-if="vm.intro.after.renewalDuration"
              class="after-starting-offer-details"
            >
              / {{ vm.intro.after.renewalDuration }}</span
            >
          </template>
          <template v-else>
            <span class="after-starting-offer-details">{{
              vm.intro.after.freeLabel
            }}</span>
          </template>
        </span>
      </span>
      <span class="price" v-else>
        <span class="amount">{{ vm.simpleAmount }}</span>
        <span class="currency">&euro;</span>
      </span>
      <span class="frequency" v-if="vm.frequency">
        {{ vm.frequency }}
      </span>
    </span>
  </div>
</template>

<script>
import PriceDisplay from "@/services/priceDisplay";

export default {
  name: "ChoicePrice",
  props: {
    choice: {
      type: Object,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    vm() {
      return PriceDisplay.buildPriceViewModel(
        this.choice,
        this.$i18n?.locale || "fr",
        { compact: this.compact },
      );
    },
  },
};
</script>

<style scoped>
.price-wrapper {
  word-break: break-word;
}
.price {
  display: block;
}
.starting-offer {
  display: block;
}
.after-starting-offer {
  display: block;
  margin-top: 2px;
}
</style>
